import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { proConRelationshipsQueryKey } from "../decisioning.keys";

const parseRelationships = (data: unknown) =>
	Dtos.Decisioning.ProConRelationship.Get.Response.schema.array().parse(data);

export const useFetchProConRelationships = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: proConRelationshipsQueryKey(accountId),
		meta: { suppressErrorModal: true },
		queryFn: async () =>
			parseRelationships(
				await get<unknown>(`/v2/admin/surety/accounts/${accountId}/pro-con-relationships`),
			),
	});

	return {
		relationships: query.data,
		relationshipsIsLoading: query.isLoading,
		relationshipsError: query.error,
		refetchRelationships: query.refetch,
	};
};
